module.exports = __webpack_public_path__ + "assets/img/8dbd2cfaafeb2b2388b71821ec544a06.webp";